import React from "react";
import i18n from "i18next";

import { NonSortableHeaderCell } from "./../../../Layout/SortedList";

const ListHeader = () => (
  <div role="row" tabIndex="0" className="sorted-list__row-header">
    <NonSortableHeaderCell className="--x5" keyName="statusDate" label={i18n.t("routing.dateTime")} />
    <NonSortableHeaderCell className="--x7" keyName="statusInfo" label={i18n.t("routing.status")} />
    <NonSortableHeaderCell className="--x4" keyName="junction" label={i18n.t("routing.location")} />
    <NonSortableHeaderCell className="--x4" keyName="contactName" label={i18n.t("routing.contactName")} />
  </div>
);

export default ListHeader;



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Routing/List/ListHeader.js